import React from 'react';

import './styles.scss';
import Loader from '../loader';
import {IChatroomDialogue} from '../../redux/chatroom/interfaces';
import ChatroomCard from '../chatroom-card';

type Props = {
  cards: IChatroomDialogue[];
  showLoader?: boolean;
  onLoadMore?: (count: number) => void;
  onClickCard: (dialogue: IChatroomDialogue) => void;
  onChangeFavorite: (dialogue: IChatroomDialogue) => void;
  checkedCards?: number[];
  disabledButtons?: boolean;
}

export const ChatroomCardSection = ({
  showLoader = false,
  cards,
  onClickCard,
  onChangeFavorite
}: Props): JSX.Element => {
  function handleClickCard(dialogue: IChatroomDialogue) {
    return () => {
      onClickCard(dialogue);
    };
  }
  function handleChangeFavorite(dialogue: IChatroomDialogue) {
    return () => {
      onChangeFavorite(dialogue);
    };
  }

  return <section className="chatroom-card-section">
    {showLoader ? <Loader/> : <ul className="chatroom-card-section__list">
      {
        cards && cards.length && cards.map((card, i) => {
          return <li key={card.id} className="chatroom-card-section__item">
            <ChatroomCard
              card={card}
              onClick={handleClickCard(card)}
              onChangeFavorite={handleChangeFavorite(card)}/>
          </li>;
        })
      }
    </ul>}
  </section>;
};
